module.exports = {
	/*
	original svg
	<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><path d="M38 26H26v12h-4V26H10v-4h12V10h4v12h12v4z"/></svg>
	@ material-design-icons/content/svg/production/ic_add_48px.svg
	*/
	d: 'M38 26H26v12h-4V26H10v-4h12V10h4v12h12v4z',
	width: 48,
	height: 48,
	
};